import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  useInsightsTracking,
  InViewTracking,
} from '@xing-com/crate-insights-tracking';

import { Styled } from './salary-banner.styled';
import SalaryIllustration from './salary-illustration.svg';

const TRACKED_LINK =
  '/start/signup?sc_o=insights_sign_up_click&sc_o_PropActionOrigin=discover_update_InsightsSalaryBanner&signup_channel=minireg_insights';

const trackData = {
  element: 'sign_up',
  element_detail: 'salary_module_banner',
  position: 3,
  verticalPosition: 3,
};

export const SalaryBanner: FC = () => {
  const { trackWithNWT } = useInsightsTracking();
  const track = (): void => trackWithNWT({ event: 'opened', ...trackData });

  return (
    <InViewTracking nwtTrackingOptions={trackData}>
      <Styled.Section onClick={track}>
        <Styled.Link to={TRACKED_LINK}>
          <Styled.Container>
            <Styled.Image src={SalaryIllustration} />
          </Styled.Container>

          <Styled.Content>
            <Styled.BodyCopy noMargin size="large" sizeConfined="xlarge">
              <FormattedMessage id="INSIGHTS_LO_SALARY_SUBTITLE" />
            </Styled.BodyCopy>
            <Styled.Title
              noMargin
              forwardedAs="h2"
              size="small"
              sizeConfined="medium"
            >
              <FormattedMessage id="INSIGHTS_LO_SALARY_TITLE" />
            </Styled.Title>
            <Styled.BodyCopy size="large" sizeConfined="xlarge">
              <FormattedMessage id="INSIGHTS_LO_SALARY_DESCRIPTION" />
            </Styled.BodyCopy>
            <Styled.ButtonLike sizeWide="large">
              <FormattedMessage id="INSIGHTS_LO_SALARY_SIGNUP_CTA" />
            </Styled.ButtonLike>
          </Styled.Content>
        </Styled.Link>
      </Styled.Section>
    </InViewTracking>
  );
};
